import styled, { css } from 'styled-components';
import { Header } from 'antd/lib/layout/layout';
import { TitleProps } from 'antd/lib/typography/Title';

export const Container = styled(Header)<{ borderColor?: string }>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem;
    align-items: center;
`;

export const Title = styled.h2<TitleProps>`
    && {
        ${({ theme }) => css`
            font-weight: '0.2';
            color: ${theme.colors.accentColor};
            font-size: ${theme.fontSizes.big};
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
            max-width: 100%;
            flex: 1;
            margin-left: 1.5rem;
            margin-bottom: 0;
        `}
    }
`;

export const WarningTextArea = styled.div`
    flex: 1;
    width: 100%;
    height: 50px;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: red;
`;
